module.exports = __webpack_public_path__ + "static/harry-potter-and-the-deathly-hallows-8506ceee6bad223d59211eda41afd7b5.jpg";